import React from "react";
import { Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProductDetailsShimmer = () => {
  return (
    <Row>
      {/* Product Images */}
      <Col xl={4} md={6}>
        <Skeleton height={500} width="100%" borderRadius={10} />

        <div className="d-flex gap-2 mt-3">
          <Skeleton width={75} height={75} borderRadius={8} />
          <Skeleton width={75} height={75} borderRadius={8} />
          <Skeleton width={75} height={75} borderRadius={8} />
          <Skeleton width={75} height={75} borderRadius={8} />
        </div>
      </Col>

      {/* Product Information */}
      <Col xl={8} md={6}>
        <div className="Product_details_info_holder">
          {/* Product title */}
          <Skeleton height={30} width="75%" className="mb-3" />

          {/* Rating */}
          <Skeleton height={20} width={120} className="mb-4" />

          {/* Price */}
          <Skeleton height={30} width={180} className="mb-4" />

          {/* Description */}
          <Skeleton count={2} className="mb-2" />

          {/* Variant heading */}
          <div className="mt-4 mb-2">
            <Skeleton width={100} height={20} />
          </div>

          {/* Variant buttons */}
          <div className="d-flex gap-2 mb-4">
            <Skeleton width={50} height={45} borderRadius={6} />
            <Skeleton width={50} height={45} borderRadius={6} />
            <Skeleton width={50} height={45} borderRadius={6} />
            <Skeleton width={50} height={45} borderRadius={6} />
          </div>

          {/* Add to cart button */}
          <Skeleton width={180} height={48} borderRadius={6} className="mb-4" />

          {/* Overview */}
          <div className="mt-3">
            <Skeleton width={150} height={22} className="mb-3" />

            <Skeleton count={3} />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ProductDetailsShimmer;
